import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { makeStyles, Paper, Theme, Typography } from "@material-ui/core";
import { AppBarSaveButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { Save } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { defaultValues, News } from "../../domain/News";
import { createItem, inputtingItem } from "../../redux/actions";
import { authSelector, createItemSelector } from "../../redux/selectors";
import { ModuleAppBar } from "../ModuleAppBar";
import { SectionProps } from "../sections/SectionProps";
import { NewsDetails } from "../sections/NewsDetails";

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
    formSection: {
      padding: 30,
      boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      borderRadius: "3px",
    },
  };
});

export const NewItem: React.FC = () => {
  const dispatch = useDispatch();

  const { userType, token } = useSelector(authSelector);

  useEffect(() => {
    dispatch(inputtingItem());
  }, [dispatch]);

  const classes = useStyles();
  const {
    handleSubmit,
    errors,
    control,
    formState,
    getValues,
    setError,
    clearErrors,
    setValue,
  } = useForm<News>({
    defaultValues: defaultValues,
  });
  const createState = useSelector(createItemSelector);
  const { status } = createState;
  const disabled = status === "CREATING";

  const onSubmit = (model: News) => {
    dispatch(createItem(model));
  };

  const sectionProps: SectionProps<News> = {
    user: { userType, token },
    disabled,
    control,
    errors,
    formState,
    setValue: (name, value) => setValue(name, value),
    getValues,
    registerCustomError: (name: keyof News, isError: boolean) => {
      const isCurrentlyARegisteredError = Object.keys(errors).includes(name);
      if (isError && !isCurrentlyARegisteredError) {
        setError(name, {});
      }
      if (!isError && isCurrentlyARegisteredError) {
        clearErrors(name);
      }
    },
  };

  return (
    <>
      <div className={classes.root}>
        <ModuleAppBar breadcrumbs={[{ label: "New article" }]}>
          <AppBarSaveButton
            lifecycleLabels={["Save", "Saving", "Saved"]}
            isSubmitting={createState.status === "CREATING"}
            isSubmitted={createState.lastCrudResult.isSuccess}
            onClick={handleSubmit(onSubmit)}
            disabled={disabled}
            Icon={Save}
            dataTest="save"
          />
        </ModuleAppBar>
        <form>
          <Typography variant="h6">News details</Typography>

          <Paper className={classes.formSection}>
            <NewsDetails {...sectionProps} />
          </Paper>
        </form>
      </div>
    </>
  );
};
